<template>
  <r-panel :disabled="disabled" :title="title" :button_add="true" @click_add="click_add">
    <r-item-kind-table ref="table" :items.sync="values" :toolbar="false"/>
  </r-panel>
</template>

<script>


import VueTypes from "vue-types";

import RItemKindTable from "@/modules/redactor/views/item/r-item-kind-table.vue";
import RPanel from "@/modules/redactor/views/utils/r-panel.vue";

import { ItemKindModel } from "@/modules/redactor/models/item/core/ItemKindModel";

export default {
  name: "r-item-kind-panel",
  components: {RPanel, RItemKindTable},
  props: {
    disabled: VueTypes.bool.def(false),
    title: VueTypes.string.def("Item Kinds"),
    items: VueTypes.arrayOf(ItemKindModel),
  },
  computed: {
    values() {
      if (this.items) {
        return this.items;
      } else {
        let values = [];
        this.$emit("update:items", values);
        return values;
      }
    }
  },
  methods: {
    click_add() {
      this.$refs["table"].row_create();
    }
  }
}

</script>
